import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './TestRide.css';

const pub = process.env.PUBLIC_URL;

const initialForm = {
  name: '',
  email: '',
  phone: '',
  city: '',
  model: 'Narsimha',
  date: '',
};

const steps = [
  {
    num: '01',
    title: 'Pick your slot',
    text: 'Choose a date and city that works for you. Our team will confirm your booking within 24 hours.',
  },
  {
    num: '02',
    title: 'Gear up with us',
    text: 'Helmets and safety gear are provided. A brief orientation covers the controls and the course.',
  },
  {
    num: '03',
    title: 'Ride the terrain',
    text: 'Take the Narsimha through inclines, mud, and trails with an Acriolis expert riding alongside.',
  },
];

function TestRide() {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // hook up to your booking endpoint here
    setSubmitted(true);
  };

  return (
    <div>
      <Header />

      {/* ── Hero ── */}
      <section
        className="tr-hero"
        style={{ backgroundImage: `url(${pub}/cta-defence.png)` }}
      >
        <div className="tr-hero__overlay" />
        <div className="tr-hero__content">
          <span className="tr-hero__eyebrow">FEEL THE POWER</span>
          <h1 className="tr-hero__heading">Book Your Free Test Ride</h1>
          <p className="tr-hero__text">
            Feel the power of Acriolis ATVs in action. No cost, no commitment — just you,
            the machine, and the terrain.
          </p>
        </div>
      </section>

      {/* ── Steps ── */}
      <section className="tr-steps">
        {steps.map((s) => (
          <div className="tr-steps__item" key={s.num}>
            <span className="tr-steps__num">{s.num}</span>
            <div>
              <h3 className="tr-steps__title">{s.title}</h3>
              <p className="tr-steps__text">{s.text}</p>
            </div>
          </div>
        ))}
      </section>

      {/* ── Booking form ── */}
      <section className="tr-form-wrap">
        <h2 className="tr-form__heading">Reserve your slot</h2>
        {submitted ? (
          <div className="tr-form__success">
            <span className="tr-form__success-icon">✓</span>
            <h3 className="tr-form__success-title">Request received!</h3>
            <p className="tr-form__success-text">
              Thanks, {form.name || 'rider'} — our team will reach out within 24 hours to
              confirm your test ride.
            </p>
          </div>
        ) : (
          <form className="tr-form" onSubmit={handleSubmit}>
            <div className="tr-form__row">
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-name">Your Name</label>
                <input
                  id="tr-name"
                  type="text"
                  name="name"
                  placeholder="John Wick"
                  value={form.name}
                  onChange={handleChange}
                  className="tr-form__input"
                  required
                />
              </div>
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-email">Email Address</label>
                <input
                  id="tr-email"
                  type="email"
                  name="email"
                  placeholder="ceo@acriolisindiamotors.com"
                  value={form.email}
                  onChange={handleChange}
                  className="tr-form__input"
                  required
                />
              </div>
            </div>

            <div className="tr-form__row">
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-phone">Phone Number</label>
                <input
                  id="tr-phone"
                  type="tel"
                  name="phone"
                  placeholder="+91 99582 53628"
                  value={form.phone}
                  onChange={handleChange}
                  className="tr-form__input"
                  required
                />
              </div>
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-city">City</label>
                <input
                  id="tr-city"
                  type="text"
                  name="city"
                  placeholder="Your city"
                  value={form.city}
                  onChange={handleChange}
                  className="tr-form__input"
                />
              </div>
            </div>

            <div className="tr-form__row">
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-model">Model</label>
                <select
                  id="tr-model"
                  name="model"
                  value={form.model}
                  onChange={handleChange}
                  className="tr-form__input tr-form__select"
                >
                  <option>Narsimha</option>
                  <option>Other / Not sure yet</option>
                </select>
              </div>
              <div className="tr-form__field">
                <label className="tr-form__label" htmlFor="tr-date">Preferred Date</label>
                <input
                  id="tr-date"
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  className="tr-form__input"
                />
              </div>
            </div>

            <button type="submit" className="tr-form__btn">
              Book Test Ride <span>→</span>
            </button>
          </form>
        )}
      </section>

      <Footer />
    </div>
  );
}

export default TestRide;
